import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import { Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, Pagination, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { t } from "i18next";

function HistoryCasino() {
    function formatDateGame(timeStr) {
        var m = new Date(timeStr);
        m.setHours(m.getHours() - 1);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2) +
            ":" +
            ("0" + m.getSeconds()).slice(-2);
    
        return dateString;
    }
    const [data, setData] = useState(null);
    const [data2, setData2] = useState(null);
    const [load, setLoad] = useState(true);
    const [endDate, setEndDate] = useState(new Date());
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    const [searched, setSearched] = useState("");
    const [pages, setPage] = useState(1);
    const [isLoading, setLoading] = useState(false);
  const requestSearch = (searchedVal) => {
        setSearched(searchedVal);

        if (searchedVal !== "") {
            const filteredRows = data2.filter((row) => {
                const a =
                    row?.user?.username?.toString().toLowerCase().includes(searchedVal.toString().toLowerCase()) ||
                    searchedVal.toString().toLowerCase().includes(row?.user?.username?.toString().toLowerCase());
                const b = Number(row?.user?.iduser).toString().toLowerCase().includes(searchedVal.toString().toLowerCase());
                const c = row?.sanh?.toString().toLowerCase().includes(searchedVal.toString().toLowerCase());
                return c || b || a;
            });
            setData(filteredRows);
            setPage(1);
        } else {
            // SỬA TẠI ĐÂY: Khi xóa hết chữ, hiển thị lại dữ liệu gốc từ data2
            setData(data2); 
            setPage(1);
        }
    };
    const handleChange = (e, page) => {
        setPage(page);
    };
    useEffect(() => {
        if (load === true) {
            axios
                .post(`https://server.vip8bet.net/casino/history`, {})
                .then((res) => {
                    setData2(res.data.data);
                    setData(res.data.data);
                    setLoad(false);
                })
                .then((res) => setLoad(true));
        }
    }, [load]);
    const selectHistory = (date) => {
        setLoading(true);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const formattedDate = `${year}${month}${day}`;
        axios
            .post(`https://server.vip8bet.net/casino/history`, { date: formattedDate })
            .then((res) => {
                setData2(res.data.data);
                setData(res.data.data);
                setLoading(false);
            })
            .then((res) => {
                setLoad(true);
                setLoading(false);
            });
    };
    if (data !== null) {
        return (
            <>
                <ThemeProvider theme={theme}>
                    <DashboardLayout>
                        {
                            <Box
                                component="main"
                                sx={{
                                    flexGrow: 1,
                                    py: 1
                                }}>
                                {isLoading ? (
                                    <div className="loading" style={{ maxWidth: "100%" }}>
                                        <div className="loader"></div>
                                    </div>
                                ) : null}
                                <Container maxWidth={false}>
                                    <div className="container_set">{t("history_api")}</div>
                                    <div className="form_set">
                                        <Box>
                                            <TextField value={searched} onChange={(searchVal) => requestSearch(searchVal.target.value)} placeholder={t("search")} />
                                            <DatePicker
                                                maxDate={new Date()}
                                                selected={endDate}
                                                onChange={(date) => {
                                                    setEndDate(date);
                                                    selectHistory(date);
                                                }}
                                            />
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell sx={{ padding: "10px" }}>ID</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>{t("username")}</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>{t("money")}</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>{t("money_win")}</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>{t("game")}</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>{t("type_transaction")}</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>{t("time")}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                {data && (
                                                    <TableBody>
                                                        {data?.slice((pages - 1) * 20, (pages - 1) * 20 + 20).map((item) => (
                                                            <>
                                                                <TableRow>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.betOrderNo}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.username.substring(1)}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.betAmount?.toLocaleString()}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.winAmount?.toLocaleString()}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.gameName}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.gameCategory}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{formatDateGame(item?.transactionTime)}</TableCell>
                                                                </TableRow>
                                                            </>
                                                        ))}
                                                    </TableBody>
                                                )}
                                            </Table>
                                        </Box>
                                    </div>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            pt: 3
                                        }}>
                                        {data != null ? <Pagination color="primary" count={Math.floor(data.length / 20) + 1} size="small" onChange={handleChange} /> : null}
                                    </Box>
                                </Container>
                            </Box>
                        }
                    </DashboardLayout>
                </ThemeProvider>
            </>
        );
    }
}
export default HistoryCasino;
